import React, { Component } from "react";
import ReactTable from "react-table";

import { toast } from "react-toastify";
import { Header, Divider, Menu, Button, Icon } from "semantic-ui-react";
import { DatesRangeInput } from "semantic-ui-calendar-react";
import Money from "../Shared/Money";

import io from "../socketConnection";
import moment from "moment";
import _ from "lodash";
import ReactToPrint from "react-to-print";

class SalesTaxTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      datesRange: `${moment()
        .startOf("month")
        .format("MM-DD-YYYY")} - ${moment()
        .endOf("month")
        .format("MM-DD-YYYY")}`,
      totals: {},
      loading: false
    };
  }
  componentDidMount() {
    this.getTransactions();
  }
  componentDidUpdate(prevProps, prevState) {
    // Get the transactions when sorting, filtering or the page was changed
    if (
      !_.isEqual(
        { datesRange: prevState.datesRange },
        { datesRange: this.state.datesRange }
      )
    ) {
      this.getTransactions();
    }
  }
  getTransactions = _.debounce(() => {
    if (this.state.loading === true) return;
    this.setState({ loading: true });

    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    let splitDates = this.state.datesRange.split(" - ");

    startDate = splitDates && splitDates[0];
    endDate = splitDates && splitDates[1];

    io.socket.get(
      "/api/v4/reports/getSalesTax",
      {
        startDate: startDate || new Date(),
        endDate: endDate
      },
      (body, jwr) => {
        if (jwr.statusCode !== 200) {
          toast.error("Failed to retrieve all transactions.");
          this.setState({ loading: false });
        }
        this.setState({
          data: body,
          loading: false
        });
      }
    );
  }, 300);
  handleChange = (event, { name, value }) => {
    this.setState({ [name]: value });
  };
  render() {
    let { data, datesRange, loading } = this.state;

    let totals = {
      totalGroomCharge: _.sumBy(data, "Transaction.serviceFeeGroom"),
      totalGeneratorCharge: _.sumBy(data, "Transaction.serviceFeeGenerator"),
      totalTripCharge: _.sumBy(data, "Transaction.serviceFeeTrip"),
      totalFuelCharge: _.sumBy(data, "Transaction.serviceFeeFuel"),
      totalDiscount: _.sumBy(data, "Transaction.serviceDiscountTotal"),
      totalCancelFee: _.sumBy(data, "cancelFee"),
      totalTaxable: _.sumBy(data, "taxable"),
      totalSalesTax: _.sumBy(data, "Transaction.serviceFeeSalesTax")
    };

    return (
      <div ref={el => (this.componentRef = el)}>
        <Menu text stackable className="responsive-header">
          <Menu.Item>
            <Header as="h2">Sales Tax Report</Header>
          </Menu.Item>
          <Menu.Item>
            <DatesRangeInput
              animation="none"
              dateFormat="MM-DD-YYYY"
              name="datesRange"
              iconPosition="left"
              placeholder="From - To"
              value={datesRange}
              style={{ minWidth: "220px" }}
              onChange={this.handleChange}
            />
          </Menu.Item>
          <Menu.Menu position="right" className="no-print">
            <Menu.Item>
              <ReactToPrint
                pageStyle=""
                trigger={() => (
                  <Button
                    icon
                    onClick={() => {
                      window.print();
                      return false;
                    }}
                  >
                    <Icon name="print" />
                  </Button>
                )}
                fluid
                content={() => this.componentRef}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        <Divider hidden fitted clearing />
        <ReactTable
          data={data}
          filterable={false}
          sortable={false}
          loading={loading}
          className="-striped"
          pageSize={data.length}
          showPagination={false}
          minRows={4}
          columns={[
            {
              Header: "Grand Totals",
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Stylist",
                  accessor: data => {
                    return `${
                      data.Appointment &&
                      data.Appointment.Employee &&
                      data.Appointment.Employee.User
                        ? `${data.Appointment.Employee.User.firstName ||
                            ""} ${data.Appointment.Employee.User.lastName ||
                            ""}`
                        : ""
                    }`;
                  },
                  id: "employee",
                  minWidth: 150
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalGroomCharge} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Groom Charge",
                  accessor: "Transaction.serviceFeeGroom",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalTripCharge} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Trip Charge",
                  accessor: "Transaction.serviceFeeTrip",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalGeneratorCharge} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Generator Charge",
                  accessor: "Transaction.serviceFeeGenerator",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalFuelCharge} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Fuel Charge",
                  accessor: "Transaction.serviceFeeFuel",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalDiscount} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Discounts",
                  accessor: "Transaction.serviceDiscountTotal",
                  Cell: props => <Money value={-props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalCancelFee} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Cancel Fees",
                  accessor: "cancelFee",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalTaxable} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Total Taxable",
                  accessor: "taxable",
                  Cell: props => <Money value={props.value} />,
                  className: "money-column important-column"
                }
              ]
            },
            {
              Header: () => <Money value={totals.totalSalesTax} />,
              headerClassName: "important-column",
              columns: [
                {
                  Header: "Sales Tax",
                  accessor: "Transaction.serviceFeeSalesTax",
                  Cell: props => (
                    <Money value={parseFloat(props.value).toFixed(2)} />
                  ),
                  className: "money-column"
                }
              ]
            }
          ]}
        />
      </div>
    );
  }
}

export default SalesTaxTable;
